import { render, staticRenderFns } from "./FigureImports.vue?vue&type=template&id=1a97c43b&"
import script from "./FigureImports.vue?vue&type=script&lang=js&"
export * from "./FigureImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a97c43b')) {
      api.createRecord('1a97c43b', component.options)
    } else {
      api.reload('1a97c43b', component.options)
    }
    module.hot.accept("./FigureImports.vue?vue&type=template&id=1a97c43b&", function () {
      api.rerender('1a97c43b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Import/Components/FigureImports.vue"
export default component.exports